import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import PageHeader from '../components/PageHeader'
import BackHome from '../components/BackHome'
import { useFirebase } from "gatsby-plugin-firebase"


const Warunki = () => {

  useFirebase(firebase => {
    firebase
      .analytics()
      .logEvent("visited_warunki")
  }, [])

  return (
  <Layout>
    <Helmet>
      <title>Harmonogram zajęć - Uczelnie Szkołom – o finansach z NBP</title>
      <meta name="description" content="Harmonogram zajęć" />
    </Helmet>

    <PageHeader headerText="Harmonogram zajęć dydaktycznych projektu: 'Uczelnie szkołom o finansach z NBP'" />

    <div id="main">
      <section id="one">
        <div className="inner">
        <h3>Terminy: <a href="#termin2810" style={{opacity:"0.3"}}>28.10</a>, <a href="#termin0411" style={{opacity:"0.3"}}>4.11</a>, <a href="#termin1811" style={{opacity:"0.3"}}>18.11</a>, <a href="#termin2511">25.11</a>, <a href="#termin0212">02.12</a>.<br/>
          Zajęcia prowadzone zdalnie poprzez wykorzystanie platformy Zoom</h3>
        <hr/>

        <div style={{opacity:"0.3"}}>
        <a name="termin2810" /><h2>TERMIN – 28.10.2020</h2>

        <p><b>Grupa 1</b> – I Liceum Ogólnokształcące im. Seweryna Goszczyńskiego, Plac Krasińskiego 1, 34-400 Nowy Targ</p>
        <p><b>LINK: </b><a href="https://zoom.us/j/3834601554?pwd=VmNDaU81RmpRck54ZENEL2l3QjUwZz09">https://zoom.us/j/3834601554?pwd=VmNDaU81RmpRck54ZENEL2l3QjUwZz09</a><br/>
        <b>Meeting ID: </b>383 460 1554<br/>
        <b>Passcode: </b>7ksQds</p>
        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pretesty</li>
          <li>9.15-10.45 – blok zajęciowy: Oszczędzanie i inwestowanie (2 godz.)</li>
          <li>10.45-11.30 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju, Kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – posttesty, podsumowanie zajęć</li>
        </ul>

        <p><b>Grupa 2</b> – Zespół Szkół im. Hugona Kołłątaja w Jordanowie, ul. Kolejowa 9, 34-240 Jordanów</p>
        <p><b>LINK: </b><a href="https://zoom.us/j/99160255764?pwd=aXFjY2RZMHdDM25lL1hGemhneVFtQT09">https://zoom.us/j/99160255764?pwd=aXFjY2RZMHdDM25lL1hGemhneVFtQT09</a><br/>
        <b>Meeting ID: </b>991 6025 5764<br/>
        <b>Passcode: </b>152226</p>
        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pretesty</li>
          <li>9.15-10.00 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>10.00-11.30 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju (2 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Oszczędzanie i inwestowanie , Kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – posttesty, podsumowanie zajęć</li>
        </ul>
        
        <a name="termin0411" /><h2>TERMIN – 04.11.2020</h2>
        
        <p><b>Grupa 1</b> – I Liceum Ogólnokształcące im. Seweryna Goszczyńskiego, Plac Krasińskiego 1, 34-400 Nowy Targ</p>
        <p><b>LINK: </b><a href="https://zoom.us/j/95300333027?pwd=VWtDUkwwbml2MzdFMksvWEs1Q2Jrdz09">https://zoom.us/j/95300333027?pwd=VWtDUkwwbml2MzdFMksvWEs1Q2Jrdz09</a><br/></p>

        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pretesty</li>
          <li>9.15-10.45 – blok zajęciowy: Oszczędzanie i inwestowanie (2 godz.)</li>
          <li>10.45-11.30 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju, Kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – posttesty, podsumowanie zajęć</li>
        </ul>

        <p><b>Grupa 2</b> – Liceum Ogólnokształcące im. Oswalda Balzera w Zakopanem, Słoneczna 1, 34-500 Zakopane</p>
        <p><b>LINK: </b><a href="https://zoom.us/j/95160968559?pwd=N3RlQkJwMXBDVTh5QzNRWVoxR1FmUT09">https://zoom.us/j/95160968559?pwd=N3RlQkJwMXBDVTh5QzNRWVoxR1FmUT09</a><br/></p>
        
        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pretesty</li>
          <li>9.15-10.00 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>10.00-11.30 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju (2 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Oszczędzanie i inwestowanie , Kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – posttesty, podsumowanie zajęć</li>
        </ul>

        <a name="termin1811" /><h2>TERMIN – 18.11.2020</h2>

        <p><b>Grupa 1</b> – Liceum Ogólnokształcące im. Oswalda Balzera w Zakopanem, Słoneczna 1, 34-500 Zakopane</p>
        <p><b>LINK: </b><a href="https://zoom.us/j/98843573085?pwd=RGVhU0kvUFB3TS9VdHNtUWQwdUtTQT09">https://zoom.us/j/98843573085?pwd=RGVhU0kvUFB3TS9VdHNtUWQwdUtTQT09</a><br/></p>
        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pretesty</li>
          <li>9.15-10.45 – blok zajęciowy: Oszczędzanie i inwestowanie (2 godz.)</li>
          <li>10.45-11.30 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju, kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – posttesty, podsumowanie zajęć</li>
        </ul>

        <p><b>Grupa 2</b> – I Liceum Ogólnokształcące im. Seweryna Goszczyńskiego, Plac Krasińskiego 1, 34-400 Nowy Targ</p>
        <p><b>LINK: </b><a href="https://zoom.us/j/91889931720?pwd=TWE4ejU1WVZSaXZ4NUZxTnR2WmRIQT09">https://zoom.us/j/91889931720?pwd=TWE4ejU1WVZSaXZ4NUZxTnR2WmRIQT09</a><br/></p>
        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pretesty</li>
          <li>9.15-10.00 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>10.00-11.30 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju (2 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Oszczędzanie i inwestowanie, kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – posttesty, podsumowanie zajęć</li>
        </ul>
        </div>

        <a name="termin2511" /><h2>TERMIN – 25.11.2020</h2>

        <p><b>Grupa 1</b> – I Liceum Ogólnokształcące im. Seweryna Goszczyńskiego, Plac Krasińskiego 1 34-400 Nowy Targ</p>
        <p><b>LINK: </b><a href="https://zoom.us/j/99239507006?pwd=ZG55ZXE3bmFxdHZDNzRzVUtIRjR1UT09">https://zoom.us/j/99239507006?pwd=ZG55ZXE3bmFxdHZDNzRzVUtIRjR1UT09</a><br/></p>
        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pre-testy</li>
          <li>9.15-10.45 – blok zajęciowy: Oszczędzanie i inwestowanie (2 godz.)</li>
          <li>10.45-11.30 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju, kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – post-testy, podsumowanie zajęć</li>
        </ul>

        <p><b>Grupa 2</b> – Zespół Szkół Ponadpodstawowych im. Inż. Józefa Marka, Marka 2, 34-730 Mszana Dolna</p>
        <p><b>LINK: </b><a href="https://zoom.us/j/98703714019?pwd=QisrWHovNXFuOFRnbXU3ZEl2VFdsZz09">https://zoom.us/j/98703714019?pwd=QisrWHovNXFuOFRnbXU3ZEl2VFdsZz09</a><br/></p>
        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pre-testy</li>
          <li>9.15-10.00 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>10.00-11.30 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju (2 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Oszczędzanie i inwestowanie, kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – post-testy, podsumowanie zajęć</li>
        </ul>

        <a name="termin0212" /><h2>TERMIN – 02.12.2020</h2>

        <p><b>Grupa 1</b> – I Liceum Ogólnokształcące im. Seweryna Goszczyńskiego, Plac Krasińskiego 1, 34-400 Nowy Targ</p>
        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pretesty</li>
          <li>9.15-10.45 – blok zajęciowy: Oszczędzanie i inwestowanie (2 godz.)</li>
          <li>10.45-11.30 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju, Kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – posttesty, podsumowanie zajęć</li>
          <li>14.30 -15.00 – obiad (grupa 1 i grupa 2 łącznie)</li>
        </ul>

        <p><b>Grupa 2</b> – Zespół Szkół Technicznych i Placówek im. Stanisława Staszica w Nowym Targu, Ul. Wojska Polskiego 9, 34-400 Nowy Targ</p>
        <ul>
          <li>9.00-9.15 – przywitanie uczestników, pretesty</li>
          <li>9.15-10.00 – blok zajęciowy: Obrót gotówkowy i bezgotówkowy, technologia blockchain (1 godz.)</li>
          <li>10.00-11.30 – blok zajęciowy: Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju (2 godz.)</li>
          <li>11.30-12.00 – przerwa herbaciana (grupa 1 i grupa 2 - łącznie)</li>
          <li>12.00-14.15 – blok zajęciowy: Oszczędzanie i inwestowanie, kredyty, pożyczki, ubezpieczenia (3 godz.)</li>
          <li>14.15-14.30 – posttesty, podsumowanie zajęć</li>
          <li>14.30 -15.00 – obiad (grupa 1 i grupa 2 - łącznie)</li>
        </ul>

        <hr/>

        <h3>Osoby odpowiedzialne:</h3>
        <ol>
          <li>Obrót gotówkowy i bezgotówkowy, technologia blockchain – Prof. UEK dr hab. Robert Włodarczyk</li>
          <li>Oszczędzanie i inwestowanie, kredyty, pożyczki, ubezpieczenia – dr Dorota Kuder/dr Agnieszka Witoń</li>
          <li>Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju – dr Dorota Kuder/dr Agnieszka Witoń</li>
          <li>Przywitanie słuchaczy, podsumowanie oraz pretesty i postesty – dr Paweł Zamora/dr Marcin Surówka.</li>
        </ol>
       </div>
      
      </section>
      <BackHome />
    </div>
  </Layout>
  )
}

export default Warunki
